import { getNode, type ViewQueryField, type ViewQueryNode } from '@salescore/core'
import { Array, Equivalence } from 'effect'

export const getReferencingNode = ({
  field,
  queryTree,
}: {
  field: ViewQueryField
  queryTree: ViewQueryNode
}): ViewQueryNode | undefined => {
  // 参照項目でなければ早期return。参照項目かどうかをmetaTypeで判定
  // XXX: relationかつnameのとき、metaTypeはnameになっているためnameも許す。参照項目でないときは、後続でundefinedになるので問題ない
  if (field.meta.fieldMetaType !== 'relation' && field.meta.fieldMetaType !== 'name') {
    return undefined
  }
  const node = getNode(queryTree, field.nodePath)
  if (node === undefined) {
    return undefined
  }
  // eslint-disable-next-line sonarjs/todo-tag
  // 参照しているノードを取得（TODO: labelNodePathを使う形はやや微妙そう）
  const referencingNode = (node.children ?? []).find((child) =>
    Array.makeEquivalence(Equivalence.String)(child.path, field.read.labelNodePath ?? []),
  )
  return referencingNode
}
